import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Permissions from '../containers/PermissionContainer';
import Channels from '../containers/ChannelContainer';
import {
  selectors as permissionSelectors,
  actions as permissionActions
} from '../store/permissions';


const mapStateToProps = ({ permissionReducer, appReducer }, { match }) => ({
  slug: match.params.permSlug,
  permission: permissionSelectors.selectPermissionBySlug(
    permissionReducer,
    match.params.permSlug
  ),
  brand: appReducer.brand
});

const mapDispatchToProps = (dispatch, { userId }) => ({
  fetchPermissions: () => dispatch(permissionActions.fetchPermissions(userId))
});

class SlugHandler extends Component {
  componentDidMount() {
    this.props.fetchPermissions();
  }
  render() {
    const { permission, match, history, brand } = this.props;
    const routerProps = { match, history };
    routerProps.match.params.prodId = permission.id;
    routerProps.match.params.permId = permission.id;
    if (permission.parentId) {
      routerProps.match.params.prodId = permission.parentId;
      return <Channels brand={brand} {...routerProps} />;
    }
    if (permission.children && permission.children.length) {
      return <Permissions brand={brand} {...routerProps} />;
    }
    return <Channels brand={brand} {...routerProps} />
  }
}
SlugHandler.propTypes = {
  permission: PropTypes.shape({
    id: PropTypes.string.isRequired,
    parentId: PropTypes.string,
    children: PropTypes.array
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      prodId: PropTypes.string,
      permId: PropTypes.string
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
  fetchPermissions: PropTypes.func.isRequired,
  brand: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SlugHandler);
